import {clsx} from 'clsx';
import React from 'react';

import {
  TimeRange,
  useHistoricUsageChartContext,
} from './HistoricUsageChartContextProvider';

export const TimeRangePicker = () => {
  const {setSelectedTimeRange, selectedTimeRange, processedData} =
    useHistoricUsageChartContext();

  const hasLessThan12MonthsData = processedData?.some(
    ({hideValue}) => hideValue
  );

  const onTimeRangeAction = (timeRange: TimeRange) =>
    (hasLessThan12MonthsData !== true ||
      timeRange === TimeRange.LAST_12_MONTHS) &&
    setSelectedTimeRange(timeRange);

  return (
    <div className="flex">
      {Object.values(TimeRange).map(timeRange => (
        <div
          key={timeRange}
          onClick={() => onTimeRangeAction(timeRange)}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              onTimeRangeAction(timeRange);
            }
          }}
          className={clsx(
            'mr-1 px-[9px] py-3 font-semibold first:rounded-l last:mr-0 last:rounded-r',
            timeRange === selectedTimeRange
              ? 'bg-teal-300/[.48] text-teal-600'
              : hasLessThan12MonthsData === true &&
                  timeRange === TimeRange.LAST_24_MONTHS
                ? 'cursor-auto opacity-[.3]'
                : 'cursor-pointer bg-oblivion/5 text-moon-500'
          )}>
          {timeRange}
        </div>
      ))}
    </div>
  );
};
